import { render, staticRenderFns } from "./kxsWill.vue?vue&type=template&id=40233fde&"
import script from "./kxsWill.vue?vue&type=script&lang=js&"
export * from "./kxsWill.vue?vue&type=script&lang=js&"
import style0 from "./kxsWill.vue?vue&type=style&index=0&id=40233fde&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports